// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__MEpnh","Logo":"Footer_Logo__PCB4-"};